export default "__VITE_ASSET__e45c43a1__"